import {
  ItemToSplitSchema,
  attributesForNewFulfillmentGroupsSchema,
} from "@redotech/redo-model/fulfillments/split-fulfillment-group";
import * as z from "zod/v4";

export const splitFulfillmentGroup = {
  name: "splitFulfillmentGroup" as const,
  input: z.object({
    originalGroupId: z.string(),
    itemsToSplit: z.array(ItemToSplitSchema),
    attributesForNewFulfillmentGroups:
      attributesForNewFulfillmentGroupsSchema.nullish(),
  }),
  output: z.object({
    success: z.boolean(),
    warningMessage: z.string().nullish(),
    newGroupIds: z.array(z.string()).nullish(),
    newGroupsByRedoOrderId: z.record(z.string(), z.array(z.string())).nullish(),
  }),
};
